export const ERRORS = {
  err_schedule_type_invalid: 'Schedule type is invalid',
  err_location_missing: 'Location missing',
  err_location_invalid: 'Location invalid',
  err_interview_kind_missing: 'Interview type missing',
  err_interview_kind_invalid: 'Interview type invalid',
  err_participant_ids_missing: 'Interviewer missing',
  err_participant_ids_invalid: 'Interviewer invalid',
  err_office_id_missing: 'Office missing',
  err_office_id_invalid: 'Office invalid',
  err_invalid_timezone: 'Timezone invalid',
  err_ats_schedule_not_found: 'Schedule not found',
  err_slots_missing: 'Please add time slots',
  err_time_slot_range_invalid: 'Time slots range invalid',
  err_start_time_less_than_current_time:
    'Please check the slot time start time is less than current time',
  err_end_time_less_than_or_eq_to_start_time: 'End time less that start time',
  err_contact_duplicate_interview_for_same_time:
    'Duplicate interview for the same time',
};
